var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"crumbs sav-breadcrumbs mt-0 ml-0 pt-0 pb-3 px-0",attrs:{"items":_vm.filteredBreadcrumbs}})}
var staticRenderFns = []

export { render, staticRenderFns }